/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

import { DEVICE } from "src/app/globalStyles";

/* ------------------ Headings ------------------ */

export const LDBlockHeading = styled.h2`
  color: #000;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  margin-bottom: 0px;
  margin-left: 0px;
  margin-top: 0px;
  text-align: left;
  width: 100%;
`;

export const LDSectionBlockHeading = styled(LDBlockHeading)`
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 0px;
  width: auto;
`;

export const LDSectionBlockHeadingLink = styled(LDSectionBlockHeading)`
  color: #904d4d;
  text-decoration: underline;
  :hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const LDBlockSubheading = styled.h3`
  color: #904d4d;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 0px;
  margin-top: 0px;
  padding-top: 9px;
`;

export const LDBlockDate = styled(LDBlockSubheading)`
  color: #333;
  font-size: 14px;
  padding-top: 2px;
  padding-bottom: 5px;
`;

export const LDBlockSubSubheading = styled.h4`
  color: #000;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 0px;
  margin-top: 0px;
  padding-top: 9px;
  font-style: italic;
`;

/* ------------------ Body ------------------ */

export const LDBlockParagraph = styled.p`
  font-size: 14px;
  line-height: 20px;
  margin-top: 4px;
  width: auto;
  margin-block-end: 1em;
`;

export const LDBlockPTest = styled(LDBlockParagraph)`
  font-size: 12px;
  line-height: 16px;
  margin-top: 4px;
  width: auto;
  margin-block-end: 1em;
  color: #2d2d2d;
`;

export const LDBlockQuote = styled(LDBlockParagraph)`
  font-size: 14px;
  font-style: italic;
  line-height: 20px;
  margin-top: 4px;
  width: auto;
  margin-block-end: 1em;
`;

export const LDBlockUL = styled.ul`
  font-size: 14px;
  line-height: 20px;
  margin: 4px 0px 0em 27px;
  padding-left: 18px;
  width: auto;

  @media (max-width: ${DEVICE.medium}) {
    margin-bottom: 0vw;
    margin-left: 13%;
    margin-right: 7vw;
  }
`;

export const LDBlockULSmall = styled(LDBlockUL)`
  margin-left: 12px;
  margin-bottom: 14px;
  @media (max-width: ${DEVICE.medium}) {
    margin-left: 6px;
    margin-right: 7vw;
  }
`;

export const LDBlockOL = styled.ol`
  font-size: 14px;
  line-height: 20px;
  margin: 4px 0px 0em 27px;
  padding-left: 18px;
  width: auto;

  @media (max-width: ${DEVICE.medium}) {
    margin-bottom: 0vw;
    margin-left: 13%;
    margin-right: 7vw;
  }
`;

export const LDBlockOLSmall = styled(LDBlockOL)`
  margin-left: 12px;
  margin-bottom: 14px;
  @media (max-width: ${DEVICE.medium}) {
    margin-left: 6px;
    margin-right: 7vw;
  }
`;

export const LDCaption = styled.div`
  color: #cccccc;
  font-size: 12px;
`;

export const LDCode = styled.code`
  background-color: #e3e3e3;
  border-radius: 3px;
  color: #24292e;
  font-family: "IBM Plex Mono", Consolas, Liberation Mono, Menlo, Courier, monospace;
  font-size: 85%;
  margin: 0;
  padding: 0.2em 0.4em;
`;

/* ------------------ Inline ------------------ */

export const LDVLink = styled.a`
  color: #904d4d;
  text-decoration: none;
  :hover {
    text-decoration: underline;
  }
`;

export const LDRedText = styled.span`
  color: #904d4d;
`;

export const LDBreadcrum = styled.span`
  color: #cccccc;
  cursor: pointer;
  :hover {
    text-decoration: underline;
  }
`;

export const BreadcrumStem = styled.span`
  color: ${(props) => props.theme.text.subtle};
`;

/* ------------------ Table ------------------ */

export const LDTable = styled.table`
  border-collapse: collapse;
  width: 300px;
`;

export const LDTableData = styled.td`
  padding: 5px;
  border: solid 1px #777;
`;

export const LDTableHeader = styled.th`
  padding: 5px;
  border: solid 1px #777;
  background-color: lightblue;
`;
